<template>
  <Transition name="modal-fade">
    <div v-if="isVisible" class="cf-overlay" role="dialog" aria-modal="true" @click.self="handleClose">
      <Transition name="modal-slide">
        <div v-if="isVisible" class="cf-dialog cf-dialog--xl" @click.stop>

          <!-- ========== HEADER ========== -->
          <div class="cf-modal-head cf-dialog-head">
            <div class="cf-modal-head__main">
              <!-- Menu Options (visible only in article view) -->
              <div v-if="isArticleView" class="cf-headmenu">
                <button @click="toggleHeaderMenu" type="button" class="ds-btn-ghost">
                  <i class="ri-menu-line"></i><span class="hidden sm:inline"> Options</span>
                </button>
                <transition name="dropdown">
                  <div v-if="showHeaderMenu" class="ag-menu cf-headmenu-list">
                    <button @click="switchToHeaderView" type="button" class="ag-menu-item">
                      <i class="ri-pen-nib-line cf-menu-icon"></i> Modifier l'en-tête du document
                    </button>
                  </div>
                </transition>
              </div>
              <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
              <div>
                <h4 class="cf-dialog-title">{{ titleModal }}</h4>
                <p v-if="Items.docnum" class="cf-modal-head__sub">Document N° {{ Items.docnum }}</p>
                <p v-else class="cf-modal-head__sub">Document commercial</p>
              </div>
            </div>
            <button @click="handleClose" :disabled="processCount > 0" type="button" class="cf-dialog-close" :class="{ 'opacity-50 cursor-not-allowed': processCount > 0 }" aria-label="Fermer"><i class="ri-close-line"></i></button>
          </div>

          <!-- View Toggle (Header/Articles) -->
          <!--div v-if="Items.docnum" class="px-4 pb-3">
              <div class="flex gap-2 bg-gray-100 dark:bg-gray-700 p-1 rounded-xl">
                  <button @click="isArticleView = false" :class="['flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all', !isArticleView ? 'bg-white dark:bg-gray-600 text-indigo-600 dark:text-indigo-400 shadow-sm' : 'text-gray-600 dark:text-gray-400']">
      <span class="flex items-center justify-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
        </svg>
        En-tête
      </span>
                  </button>
                  <button @click="isArticleView = true" :class="['flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-all', isArticleView ? 'bg-white dark:bg-gray-600 text-indigo-600 dark:text-indigo-400 shadow-sm' : 'text-gray-600 dark:text-gray-400']">
      <span class="flex items-center justify-center gap-2">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
        </svg>
        Articles
        <span v-if="articleLines.length" class="inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-indigo-600 rounded-full">
          {{ articleLines.length }}
        </span>
      </span>
                  </button>
              </div>
          </div-->

          <!-- ========== ALERTS ========== -->
          <div v-if="successMessage || errorMessage" class="cf-alert-zone">
            <Transition name="modal-fade">
              <div v-if="successMessage" class="cf-alert cf-alert--success">
                <i class="ri-checkbox-circle-line"></i><span>{{ successMessage }}</span>
              </div>
            </Transition>
            <Transition name="modal-fade">
              <div v-if="errorMessage" class="cf-alert cf-alert--danger">
                <i class="ri-error-warning-line"></i><span>{{ errorMessage }}</span>
              </div>
            </Transition>
          </div>

          <!-- ========== CONTENT ========== -->
          <div class="cf-dialog-body">

            <!-- HEADER VIEW -->
            <div v-show="!isArticleView">
              <!-- Tabs Navigation -->
              <nav class="cf-tabs" aria-label="Tabs">
                <button v-for="(tab, index) in headerTabs" :key="index" @click="activeHeaderTab = index" type="button" class="fa2-tab" :class="{ 'fa2-tab--active': activeHeaderTab === index }">
                  {{ tab.label }}
                </button>
              </nav>

              <!-- Tab: Information de base -->
              <div v-show="activeHeaderTab === 0" class="mt-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Magasin -->
                  <div class="cf-field">
                    <label class="cf-field-label">Magasin / Dépôt / Entrepôt <span class="cf-req">*</span></label>
                    <div v-if="!isDocumentLocked" class="cf-select-wrap">
                      <select v-model="Items.mag" class="cf-inp cf-select">
                        <option :value="null">Sélectionner un entrepôt</option>
                        <option v-for="mag in returnGetAllmagasin" :key="mag.pid" :value="mag">{{ mag.name }}</option>
                      </select>
                      <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                    </div>
                    <input v-else :value="Items.mag?.name" type="text" disabled class="cf-inp cf-inp--readonly">
                  </div>

                  <!-- Date -->
                  <div class="cf-field">
                    <label class="cf-field-label">Date <span class="cf-req">*</span></label>
                    <input v-if="!isDocumentLocked" v-model="Items.datedoc" type="date" class="cf-inp">
                    <input v-else :value="Items.datedoc" type="date" disabled class="cf-inp cf-inp--readonly">
                  </div>

                  <!-- Client / Fournisseur -->
                  <div class="cf-field">
                    <label class="cf-field-label">{{ documentCategory === 'vente' ? 'Client' : 'Fournisseur' }} <span class="cf-req">*</span></label>
                    <div class="flex gap-2">
                      <input :value="Items.jsonotherdonne?.cltfrs?.name || ''" :placeholder="'Sélectionner un ' + (documentCategory === 'vente' ? 'client' : 'fournisseur')" type="text" disabled class="cf-inp cf-inp--readonly flex-1">
                      <button v-if="!isDocumentLocked" @click="openClientSupplierModal" type="button" class="ti-btn ti-btn-primary-full">
                        <i class="ri-search-line align-middle"></i><span class="hidden sm:inline"> Choisir</span>
                      </button>
                    </div>
                  </div>

                  <!-- Type de prix (vente only) -->
                  <div v-if="documentCategory === 'vente'" class="cf-field">
                    <label class="cf-field-label">Type de prix</label>
                    <div class="cf-select-wrap">
                      <select v-model="Items.jsonotherdonne.mtypprixdevente" :disabled="isDocumentLocked" class="cf-inp cf-select">
                        <option value="prixvente">{{ inputLabels.prixvente }}</option>
                        <option value="prixvente1">{{ inputLabels.prixvente1 }}</option>
                        <option value="prixvente2">{{ inputLabels.prixvente2 }}</option>
                        <option value="prixvente3">{{ inputLabels.prixvente3 }}</option>
                        <option value="prixvente4">{{ inputLabels.prixvente4 }}</option>
                        <option value="prixvente5">{{ inputLabels.prixvente5 }}</option>
                        <option value="prixvente6">{{ inputLabels.prixvente6 }}</option>
                        <option value="prixvente7">{{ inputLabels.prixvente7 }}</option>
                      </select>
                      <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                    </div>
                  </div>

                  <!-- Collaborateur (vente only) -->
                  <div v-if="documentCategory === 'vente'" class="cf-field md:col-span-2">
                    <label class="cf-field-label">Collaborateur</label>
                    <div class="flex gap-2">
                      <input :value="Items.jsonotherdonne?.collaborateur ? `${Items.jsonotherdonne.collaborateur.name} / ${Items.jsonotherdonne.collaborateur.typecollaborateur}` : ''" placeholder="Sélectionner un collaborateur" type="text" disabled class="cf-inp cf-inp--readonly flex-1">
                      <button @click="openCollaboratorModal" type="button" class="ti-btn ti-btn-primary-full">
                        <i class="ri-search-line align-middle"></i><span class="hidden sm:inline"> Choisir</span>
                      </button>
                    </div>
                  </div>

                  <!-- Motif / Raison -->
                  <div class="cf-field md:col-span-2">
                    <label class="cf-field-label">Motif / Raison <span class="cf-req">*</span></label>
                    <textarea v-model="Items.docobservation" rows="3" class="cf-inp cf-textarea" placeholder="Saisissez le motif ou la raison du document..."></textarea>
                  </div>
                </div>
              </div>

              <!-- Tab: Pieds de document -->
              <div v-show="activeHeaderTab === 1" class="mt-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Appliquer TVA -->
                  <div class="cf-field">
                    <label class="cf-field-label">Appliquer la TVA (18%)</label>
                    <div class="cf-select-wrap">
                      <select v-model="Items.jsonotherdonne.appliquetva" class="cf-inp cf-select">
                        <option value="0">Non</option>
                        <option value="1">Oui</option>
                      </select>
                      <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                    </div>
                  </div>

                  <!-- AIB -->
                  <div class="cf-field">
                    <label class="cf-field-label">AIB</label>
                    <div class="cf-select-wrap">
                      <select v-model="Items.jsonotherdonne.aib" class="cf-inp cf-select">
                        <option value="0">Aucun</option>
                        <option value="1">AIB (1%)</option>
                        <option value="3">AIB (3%)</option>
                        <option value="5">AIB (5%)</option>
                      </select>
                      <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                    </div>
                  </div>

                  <!-- Mode de règlement -->
                  <div class="cf-field">
                    <label class="cf-field-label">Mode de règlement</label>
                    <div class="cf-select-wrap">
                      <select v-model="Items.jsonotherdonne.moderglt" class="cf-inp cf-select">
                        <option :value="null">Sélectionner un mode</option>
                        <option v-for="mode in alldata.modedereglement" :key="mode.pid" :value="mode">{{ mode.name }}</option>
                      </select>
                      <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                    </div>
                  </div>

                  <!-- Condition de règlement -->
                  <div class="cf-field">
                    <label class="cf-field-label">Condition de règlement</label>
                    <div class="cf-select-wrap">
                      <select v-model="Items.jsonotherdonne.cdtreglement" class="cf-inp cf-select">
                        <option :value="null">Sélectionner une condition</option>
                        <option v-for="cdt in alldata.condictiondereglement" :key="cdt.pid" :value="cdt">{{ cdt.name }}</option>
                      </select>
                      <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                    </div>
                  </div>

                  <!-- Date de livraison -->
                  <div class="cf-field">
                    <label class="cf-field-label">Date de livraison</label>
                    <input v-model="Items.jsonotherdonne.datedelivraison" type="date" class="cf-inp">
                  </div>

                  <!-- Échéancier -->
                  <div class="cf-field">
                    <label class="cf-field-label">Échéancier</label>
                    <input v-model="Items.jsonotherdonne.dateechancefacture" type="date" class="cf-inp">
                  </div>

                  <!-- Informations libres pieds -->
                  <div class="cf-field">
                    <label class="cf-field-label">Avance</label>
                    <input v-model="Items.jsonotherdonne.piedsinfodoc.infolibre" type="text" class="cf-inp">
                  </div>

                  <div class="cf-field">
                    <label class="cf-field-label">Solde</label>
                    <input v-model="Items.jsonotherdonne.piedsinfodoc.infolibre1" type="text" class="cf-inp">
                  </div>
                </div>
              </div>

              <!-- Tab: Information libre -->
              <div v-show="activeHeaderTab === 2" class="mt-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div v-for="i in 10" :key="i" class="cf-field">
                    <label class="cf-field-label">
                      {{ customLabels.informationlibre['informationlibre' + (i === 1 ? '' : i - 1)] || `Information libre ${i}` }}
                    </label>
                    <input v-model="Items.jsonotherdonne.infodoc['infolibre' + (i === 1 ? '' : i - 1)]" type="text" class="cf-inp">
                  </div>
                </div>
              </div>

              <!-- Tab: Adresse d'expédition -->
              <div v-show="activeHeaderTab === 3" class="mt-4 space-y-4">
                <div class="grid grid-cols-1 gap-4">
                  <div class="cf-field">
                    <label class="cf-field-label">
                      {{ customLabels.adresseexpedition?.informationlibre || 'Adresse ligne 1' }}
                    </label>
                    <input v-model="Items.jsonotherdonne.adresseexpedition.infolibre" type="text" class="cf-inp">
                  </div>
                  <div class="cf-field">
                    <label class="cf-field-label">
                      {{ customLabels.adresseexpedition?.informationlibre1 || 'Adresse ligne 2' }}
                    </label>
                    <input v-model="Items.jsonotherdonne.adresseexpedition.infolibre1" type="text" class="cf-inp">
                  </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="cf-field">
                    <label class="cf-field-label">
                      {{ customLabels.adresseexpedition?.informationlibre2 || 'Ville' }}
                    </label>
                    <input v-model="Items.jsonotherdonne.adresseexpedition.infolibre2" type="text" class="cf-inp">
                  </div>
                  <div class="cf-field">
                    <label class="cf-field-label">
                      {{ customLabels.adresseexpedition?.informationlibre3 || 'Code postal' }}
                    </label>
                    <input v-model="Items.jsonotherdonne.adresseexpedition.infolibre3" type="text" class="cf-inp">
                  </div>
                </div>
              </div>
            </div>

            <!-- ARTICLES VIEW -->
            <div v-show="isArticleView">
              <!-- Article Form -->
              <div class="cf-subpanel">
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-3">
                  <!-- Article Selection -->
                  <div class="lg:col-span-5 cf-field">
                    <label class="cf-field-label">Article</label>
                    <div class="flex gap-2">
                      <input :value="currentArticle.article?.libelle || ''" placeholder="Sélectionner un article" type="text" disabled class="cf-inp cf-inp--readonly flex-1">
                      <button :disabled="isArticleDisabled || isLoadingCatalogue" @click="openArticleModal" type="button" class="ti-btn ti-btn-primary-full" :class="{ 'opacity-50 cursor-not-allowed': isArticleDisabled || isLoadingCatalogue }">
                        <i class="ri-search-line align-middle"></i><span class="hidden sm:inline"> {{ isLoadingCatalogue ? 'Chargement des articles...' : 'Rechercher' }}</span>
                      </button>
                    </div>
                  </div>

                  <!-- Prix Unitaire -->
                  <div v-if="!isSimpleDocument" class="lg:col-span-2 cf-field">
                    <label class="cf-field-label">P.U.</label>
                    <input v-if="documentCategory === 'vente'" :value="displayPrice" type="number" disabled class="cf-inp cf-inp--readonly text-right">
                    <input v-else v-model.number="currentArticle.pa" :disabled="isPriceDisabled" type="number" min="0" class="cf-inp text-right">
                  </div>

                  <!-- Quantité -->
                  <div :class="[isSimpleDocument ? 'lg:col-span-3' : 'lg:col-span-2', 'cf-field']">
                    <label class="cf-field-label">Quantité</label>
                    <input v-model.number="articleQuantity" type="number" min="0" step="0.01" class="cf-inp text-right">
                  </div>

                  <!-- Remise -->
                  <div v-if="!isSimpleDocument" class="lg:col-span-1 cf-field">
                    <label class="cf-field-label">Remise</label>
                    <input v-model.number="currentArticle.remise" type="number" min="0" class="cf-inp text-right">
                  </div>

                  <!-- Montant -->
                  <div class="lg:col-span-2 cf-field">
                    <label class="cf-field-label">Montant</label>
                    <input :value="formatCurrency(calculatedAmount)" type="text" disabled class="cf-inp cf-inp--amount text-right">
                  </div>

                  <!-- Autre désignation -->
                  <div v-if="!isSimpleDocument" class="lg:col-span-12 cf-field">
                    <label class="cf-field-label">Autre désignation</label>
                    <input v-model="currentArticle.autredesignation" type="text" placeholder="Désignation complémentaire (optionnel)" class="cf-inp">
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="flex flex-wrap gap-2 mt-4 pt-3 cf-subpanel-actions">
                  <button @click="resetArticleForm" type="button" class="ti-btn ti-btn-secondary-full"><i class="ri-add-line align-middle"></i> Nouveau</button>
                  <button @click="saveArticleLine" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-check-line align-middle"></i> Enregistrer</button>
                  <button @click="deleteArticleLine" type="button" class="ti-btn ti-btn-danger-full"><i class="ri-delete-bin-line align-middle"></i> Supprimer</button>
                </div>
              </div>

              <!-- Articles Table -->
              <div class="cf-table-wrap mt-3">
                <!-- Desktop Table -->
                <table class="cf-table hidden lg:table">
                  <thead>
                  <tr>
                    <th class="th th--center" style="width:6rem">État</th>
                    <th class="th">Désignation</th>
                    <th class="th th--right" style="width:8rem">P.U.</th>
                    <th class="th th--right" style="width:7rem">Qté</th>
                    <th class="th th--right" style="width:7rem">Remise</th>
                    <th class="th th--right" style="width:9rem">Montant</th>
                    <th class="th th--center" style="width:8rem">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-if="articleLines.length">
                    <template v-for="(line, index) in articleLines" :key="line.linekey || index">
                      <tr class="table-row">
                        <td class="td td--center">
                          <span class="cf-badge" :class="getStatusClass(line.etatline)">
                            <span class="cf-badge-dot" :class="getStatusDotClass(line.etatline)"></span>
                            {{ getStatusLabel(line.etatline) }}
                          </span>
                        </td>
                        <td class="td">
                          <p class="cf-cell-main">{{ line.article?.libelle }}</p>
                          <p v-if="line.autredesignation" class="cf-cell-sub">{{ line.autredesignation }}</p>
                        </td>
                        <td class="td td--right">{{ formatCurrency(line.pu) }}</td>
                        <td class="td td--right cf-cell-strong">{{ formatNumber(line.qtite) }}</td>
                        <td class="td td--right">{{ formatCurrency(line.remise) }}</td>
                        <td class="td td--right cf-cell-strong">{{ formatCurrency(line.calmtntht) }}</td>
                        <td class="td td--center">
                          <button @click="selectArticleLine(line)" type="button" class="ti-btn ti-btn-primary-full ti-btn-sm">
                            <i class="ri-pen-nib-line align-middle"></i> Modifier
                          </button>
                        </td>
                      </tr>
                      <!-- Error Message Row -->
                      <tr v-if="line.etatline === 2 && line.linemessage">
                        <td colspan="7" class="td cf-line-error"><span v-html="line.linemessage"></span></td>
                      </tr>
                    </template>
                  </template>
                  <tr v-else>
                    <td colspan="7" class="td">
                      <div class="empty-state">
                        <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                        <p class="empty-state__title">Aucun article ajouté</p>
                        <p class="empty-state__sub">Utilisez le formulaire ci-dessus pour ajouter des articles</p>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                  <!-- Totals Footer -->
                  <tfoot v-if="articleLines.length" class="cf-tfoot">
                  <tr>
                    <td colspan="5" class="td td--right cf-tfoot-label">Montant HT</td>
                    <td class="td td--right cf-tfoot-val">{{ formatCurrency(Items.mtnt?.doccalmtnttotalht) }}</td>
                    <td class="td"></td>
                  </tr>
                  <tr v-if="parseFloat(Items.mtnt?.docmtntremise) > 0">
                    <td colspan="5" class="td td--right cf-tfoot-label">Remise</td>
                    <td class="td td--right cf-neg">-{{ formatCurrency(Items.mtnt?.docmtntremise) }}</td>
                    <td class="td"></td>
                  </tr>
                  <tr v-if="parseFloat(Items.mtnt?.docmtntaib) !== 0">
                    <td colspan="5" class="td td--right cf-tfoot-label">{{ Items.mtnt?.libaib }}</td>
                    <td class="td td--right cf-tfoot-val">{{ formatCurrency(Items.mtnt?.docmtntaib) }}</td>
                    <td class="td"></td>
                  </tr>
                  <tr v-if="parseFloat(Items.mtnt?.doctva) > 0">
                    <td colspan="5" class="td td--right cf-tfoot-label">TVA (18%)</td>
                    <td class="td td--right cf-tfoot-val">{{ formatCurrency(Items.mtnt?.doctva) }}</td>
                    <td class="td"></td>
                  </tr>
                  <tr class="cf-tfoot-total">
                    <td colspan="5" class="td td--right">NET À PAYER</td>
                    <td class="td td--right cf-tfoot-amount">{{ formatCurrency(Items.mtnt?.docmtnttotalttc) }}</td>
                    <td class="td"></td>
                  </tr>
                  </tfoot>
                </table>

                <!-- Mobile Cards -->
                <div class="lg:hidden space-y-3 p-3">
                  <template v-if="articleLines.length">
                    <div v-for="(line, index) in articleLines" :key="line.linekey || index" class="cf-card">
                      <div class="cf-card-head">
                        <span class="cf-card-index">#{{ index + 1 }}</span>
                        <span class="cf-badge" :class="getStatusClass(line.etatline)">
                          <span class="cf-badge-dot" :class="getStatusDotClass(line.etatline)"></span>
                          {{ getStatusLabel(line.etatline) }}
                        </span>
                      </div>
                      <div class="cf-card-body">
                        <p class="cf-card-title">{{ line.article?.libelle }}</p>
                        <p v-if="line.autredesignation" class="cf-card-sub">{{ line.autredesignation }}</p>
                        <div class="grid grid-cols-2 gap-3">
                          <div>
                            <p class="cf-card-lbl">P.U.</p>
                            <p class="cf-card-val">{{ formatCurrency(line.pu) }}</p>
                          </div>
                          <div>
                            <p class="cf-card-lbl">Quantité</p>
                            <p class="cf-card-val">{{ formatNumber(line.qtite) }}</p>
                          </div>
                          <div>
                            <p class="cf-card-lbl">Remise</p>
                            <p class="cf-card-val">{{ formatCurrency(line.remise) }}</p>
                          </div>
                          <div>
                            <p class="cf-card-lbl">Montant</p>
                            <p class="cf-card-val cf-card-val--primary">{{ formatCurrency(line.calmtntht) }}</p>
                          </div>
                        </div>
                        <div class="text-right mt-3">
                          <button @click="selectArticleLine(line)" type="button" class="cf-card-link">Modifier</button>
                        </div>
                      </div>
                      <div v-if="line.etatline === 2 && line.linemessage" class="cf-card-error"><span v-html="line.linemessage"></span></div>
                    </div>

                    <!-- Mobile Totals -->
                    <div class="cf-totals-card">
                      <div class="cf-totals-row">
                        <span>Montant HT</span>
                        <span>{{ formatCurrency(Items.mtnt?.doccalmtnttotalht) }}</span>
                      </div>
                      <div v-if="parseFloat(Items.mtnt?.docmtntremise) > 0" class="cf-totals-row">
                        <span>Remise</span>
                        <span>-{{ formatCurrency(Items.mtnt?.docmtntremise) }}</span>
                      </div>
                      <div v-if="parseFloat(Items.mtnt?.doctva) > 0" class="cf-totals-row">
                        <span>TVA (18%)</span>
                        <span>{{ formatCurrency(Items.mtnt?.doctva) }}</span>
                      </div>
                      <div class="cf-totals-row cf-totals-row--net">
                        <span>NET À PAYER</span>
                        <span>{{ formatCurrency(Items.mtnt?.docmtnttotalttc) }}</span>
                      </div>
                    </div>
                  </template>
                  <div v-else class="empty-state">
                    <div class="empty-state__icon"><i class="ri-inbox-line"></i></div>
                    <p class="empty-state__title">Aucun article ajouté</p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- ========== FOOTER ========== -->
          <div class="cf-dialog-foot cf-dialog-foot--split">
            <div class="cf-foot-info">
              <!-- Process Indicator -->
              <span v-if="processCount > 0" class="cf-process">
                <i class="ri-loader-4-line animate-spin"></i> {{ processCount }} opération(s) en cours...
              </span>
            </div>
            <div class="flex items-center gap-2">
              <button @click="handleClose" :disabled="processCount > 0" type="button" class="ti-btn ti-btn-secondary-full" :class="{ 'opacity-50 cursor-not-allowed': processCount > 0 }">Fermer</button>

              <!-- Save/Validate Button (Header View) -->
              <button v-if="!isArticleView && actionType === 'add'" @click="saveDocument" type="button" class="ti-btn ti-btn-success-full">Valider</button>

              <!-- Update Button (Header View) -->
              <button v-if="!isArticleView && actionType === 'update'" @click="updateDocument" type="button" class="ti-btn ti-btn-primary-full">Modifier</button>

              <!-- Apply Button (Article View) -->
              <button v-if="isArticleView" @click="handleClose" :disabled="processCount > 0" type="button" class="ti-btn ti-btn-success-full" :class="{ 'opacity-50 cursor-not-allowed': processCount > 0 }">Appliquer</button>
            </div>
          </div>

        </div>
      </Transition>

      <!-- Child Modals -->
      <modallistfrsclt ref="modallistfrsclt" @elementSelectionnecltfrs="handleClientSupplierSelected" />
      <modallistedesarticles ref="modallistedesarticles" refreshable @actualiser="actualiserCatalogue" @elementSelectionnearticle="handleArticleSelected" />
    </div>
  </Transition>
</template>

<script>
const axios =require('axios');
import { cloneobjet, currencyFormatDE, FormatNumber,   randomString } from '@/allfunction';
import * as JwtService from '@/common/jwt.service';
import { lireCatalogueCache, ecrireCatalogueCache } from '@/service/catalogueArticlesCache';
import modallistfrsclt from '@/components/views/pages/gestioncommerciale/achatvente/modal_listfrsclt';
import modallistedesarticles from '@/components/views/pages/stock/mvtstock/modal_listedesarticles';

export default {
  /* eslint-disable */
  name: 'DocumentFormModal',

  components: {
    modallistfrsclt,
    modallistedesarticles,
  },

  data() {
    return {
      // Visibility
      isVisible: false,
      isArticleView: false,
      showHeaderMenu: false,
      activeHeaderTab: 0,

      // Messages
      successMessage: '',
      errorMessage: '',

      // Document Info
      titleModal: '',
      documentType: '',
      documentCategory: '',
      actionType: 'add',

      // Data
      Items: this.createEmptyDocument(),
      alldata: [],
      inputLabels: {},
      customLabels: {},
      clientSupplierList: [],
      productList: [],
      articleLines: [],
      currentDocMag: '',
      processCount: 0,

      // Current Article
      currentArticle: this.createEmptyArticle(),
      articleQuantity: 0,
      isArticleDisabled: false,
      isLoadingCatalogue: false,

      // Header Tabs
      headerTabs: [
        { label: 'Informations de base' },
        { label: 'Pieds de document' },
        { label: 'Informations libres' },
        { label: 'Adresse d\'expédition' },
      ],
    };
  },

  computed: {
    isDocumentLocked() {
      return this.Items.docnum !== '';
    },

    isSimpleDocument() {
      return ['BL', 'BRF'].includes(this.documentType);
    },

    isPriceDisabled() {

      //console.log("this.documentCategory ******* ",this.documentCategory)
      //console.log("this.documentType ******* ",this.documentType)



      if (this.documentCategory === 'achat') {
        //const mvalue= !['BC', 'PF'].includes(this.documentType);
        const mvalue= ['BCF', 'DAF'].includes(this.documentType);


        return !mvalue

      }
      return true;
    },

    displayPrice() {
      return this.currentArticle.article ? this.currentArticle.pu : 0;
    },

    calculatedAmount() {
      if (!this.currentArticle.article) return 0;

      let amount = 0;
      const qty = parseFloat(this.articleQuantity) || 0;
      const price = this.documentCategory === 'vente'
          ? parseFloat(this.currentArticle.pu)
          : parseFloat(this.currentArticle.pa);
      const discount = parseFloat(this.currentArticle.remise) || 0;

      amount = qty * price - discount;
      this.currentArticle.mtnt = Math.round(amount);
      return Math.round(amount);
    },

    returnGetAllmagasin() {
      if (!this.$store.state.annexeuser || this.$store.state.annexeuser.length === 0) {
        return this.alldata.magasin || [];
      }
      return this.$store.state.annexeuser;
    },
  },

  watch: {
    articleQuantity(newVal) {
      if (this.currentArticle.article) {
        this.currentArticle.qtite = parseFloat(newVal) || 0;
        this.calculateArticlePrice();
      }
    },
  },

  methods: {
    // ============ INITIALIZATION ============
    createEmptyDocument() {
      return {
        pid: '',
        mag: null,
        datedoc: '',
        docobservation: '',
        docnum: '',
        docnumother: '',
        docpid: 0,
        doctyp: '',
        infodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
        jsonotherdonne: {
          datedelivraison: '',
          dateechancefacture: '',
          tpdoc: '',
          tredocument: '',
          magvers: null,
          mtypprixdevente: 'prixvente',
          collaborateur: null,
          cltfrs: null,
          moderglt: null,
          cdtreglement: null,
          appliquetva: 1,
          aib: 0,
          adresseexpedition: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
          infodoc: {
            infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '',
            infolibre4: '', infolibre5: '', infolibre6: '', infolibre7: '',
            infolibre8: '', infolibre9: '', infolibre10: '', infolibre11: '',
          },
          piedsinfodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
        },
        mtnt: {
          docmtntaib: '0', docmtntremise: '0', docmtnttotalht: '0',
          docmtnttotalttc: '0', doctva: '0', doccalmtnttotalht: '0', libaib: 'AIB',
        },
        params: { param1: null, param2: null, param3: null, param4: null },
        jsondoc: {},
      };
    },

    createEmptyArticle() {
      return {
        autredesignation: '',
        docnum: '',
        article: null,
        qtite: 0,
        diqte: 0,
        pu: 0,
        pa: 0,
        mtnt: 0,
        mtntclt: 0,
        remise: 0,
        doc: '',
        docpid: '',
        docnumother: '',
        docmag: '',
        doctp: '',
        linekey: '',
        calmtntht: 0,
        etatline: 0,
        pid: '',
      };
    },

    // ============ MODAL METHODS ============
    show(title, action, docType, items, alldata, inputLabels, docCategory, customLabels) {
      this.titleModal = title;
      this.actionType = action;
      this.documentType = docType;
      this.documentCategory = docCategory;
      this.inputLabels = inputLabels || {};
      this.customLabels = customLabels || {};
      this.Items = items;
      this.alldata = alldata;
      this.clientSupplierList = alldata.frsclt || [];
      this.clearMessages();
      this.isArticleView = false;
      this.isVisible = true;
      document.body.style.overflow = 'hidden';
    },

    async showupdate(title, action, docType, items, alldata, inputLabels, docCategory, customLabels) {
      this.show(title, action, docType, items, alldata, inputLabels, docCategory, customLabels);
      this.resetArticleForm();

      if (items.pid) {
        this.isArticleView = true;
        await this.loadDocumentDetails(items);
      }
    },

    handleClose() {
      if (this.processCount > 0) return;
      this.close();
    },

    close() {
      this.productList = [];
      this.articleLines = [];
      this.resetArticleForm();
      this.isArticleView = false;
      this.isVisible = false;
      document.body.style.overflow = '';
      this.$emit('closed');
    },

    // ============ CACHE CATALOGUE (IndexedDB, par société + magasin, voir service/catalogueArticlesCache) ============
    // Télécharge la liste d'articles du magasin du document (route de réouverture, action "upd")
    // et la range dans le cache du poste. Lève une erreur si la liste n'est pas reçue.
    async telechargerCatalogue(pidmag) {
      const piddoc = this.Items.docpid || this.Items.pid;
      const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/${this.Items.docnum}/${piddoc}/upd/${this.$store.state.appsociete}/${randomString()}`;

      const response = await axios.get(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${JwtService.getToken()}`,
          'csrftoken': this.$store.state.appsociete,
        },
        withCredentials: true,
      });

      if (!response.data.success || !Array.isArray(response.data.m)) {
        throw new Error('Liste non reçue');
      }

      await ecrireCatalogueCache(this.$store.state.appsociete, pidmag, response.data.m);
      return response.data.m;
    },

    // Après la validation de l'en-tête : liste lue dans le cache du poste, sinon téléchargée en arrière-plan
    async chargerCatalogue() {
      const pidmag = this.currentDocMag;
      this.isLoadingCatalogue = true;

      try {
        let liste = await lireCatalogueCache(this.$store.state.appsociete, pidmag);
        if (liste.length === 0) {
          liste = await this.telechargerCatalogue(pidmag);
        }
        // Le document a pu être fermé ou changé pendant le chargement
        if (this.isVisible && this.currentDocMag === pidmag) {
          this.productList = liste;
        }
      } catch (error) {
        console.error('Error loading catalogue:', error);
        this.showError("La liste des articles n'a pas pu être chargée. Ouvrez « Rechercher » puis cliquez sur « Actualiser ».");
      } finally {
        this.isLoadingCatalogue = false;
      }
    },

    // Bouton « Actualiser » de la fenêtre de recherche : recharge la liste depuis le serveur
    async actualiserCatalogue() {
      const modal = this.$refs.modallistedesarticles;

      try {
        this.productList = await this.telechargerCatalogue(this.currentDocMag);
        modal.finActualisation(this.productList);
      } catch (error) {
        console.error('Error refreshing catalogue:', error);
        modal.finActualisation(null, "Impossible d'actualiser la liste des articles. Vérifiez la connexion puis réessayez.");
      }
    },

    // Liste reçue avec la réponse d'en-tête (serveur pas encore à jour) ou à charger à part
    appliquerListeEntete(listerecue) {
      if (Array.isArray(listerecue) && listerecue.length > 0) {
        this.productList = listerecue;
        ecrireCatalogueCache(this.$store.state.appsociete, this.currentDocMag, listerecue);
      } else {
        this.productList = [];
        this.chargerCatalogue();
      }
    },

    // ============ DATA LOADING ============
    async loadDocumentDetails(items) {
      this.$store.dispatch('lancerchargement', true);

      try {
        // Liste déjà en cache sur le poste : on ne la redemande pas au serveur (action autre que "upd")
        const pidmagcache = items.mag?.pid || '';
        const catalogue = await lireCatalogueCache(this.$store.state.appsociete, pidmagcache);
        const btnaction = catalogue.length > 0 ? 'cache' : 'upd';

        const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/${items.numdoc}/${items.pid}/${btnaction}/${this.$store.state.appsociete}/${randomString()}`;

        const response = await axios.get(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JwtService.getToken()}`,
            'csrftoken': this.$store.state.appsociete,
          },
          withCredentials: true,
        });

        if (response.data.success) {
          if (catalogue.length > 0) {
            this.productList = catalogue;
          } else {
            this.productList = response.data.m || [];
            ecrireCatalogueCache(this.$store.state.appsociete, pidmagcache, this.productList);
          }
          this.articleLines = response.data.alllignedoc || [];

          // Update Items
          this.Items.jsonotherdonne = items.jsonotherdonne;
          this.Items.mag = items.mag;
          this.Items.pid = items.pid;
          this.Items.docpid = items.pid;
          this.Items.params = items.params;
          this.Items.mtnt = items.mtnt;
          this.Items.docnum = items.numdoc;
          this.Items.docnumother = items.docnumother;
          this.Items.infodoc = items.infodoc;
          this.Items.datedoc = items.datedoc;
          this.Items.doctyp = items.doctyp;
          this.Items.docobservation = items.observations;

          // Update article context
          this.currentDocMag = items.mag?.pid || '';
          this.currentArticle.docmag = this.currentDocMag;
          this.currentArticle.docnum = items.pid;
          this.currentArticle.docpid = items.pid;
          this.currentArticle.doctp = items.doctyp;
          this.currentArticle.docnumother = items.docotherref;

          this.calculateDocumentTotals();
        }
      } catch (error) {
        console.error('Error loading document details:', error);
      } finally {
        this.$store.dispatch('lancerchargement', false);
      }
    },

    // ============ DOCUMENT SAVE/UPDATE ============
    async saveDocument() {
      if (!this.validateDocument()) return;

      this.$store.dispatch('lancerchargement', true);

      try {
        const url = `${process.env.VUE_APP_API_URL}/jkebfgescomporziprodpfachatventeegl745874stock771714dfe/gescom/default/vadd/${this.documentCategory}/${this.documentType}/${this.$store.state.appsociete}/${randomString()}`;

        // sansliste : le serveur ne renvoie plus la liste d'articles avec l'en-tête
        const response = await axios.post(url, { ...this.Items, sansliste: 1 }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JwtService.getToken()}`,
            'csrftoken': this.$store.state.appsociete,
          },
          withCredentials: true,
        });

        if (response.data.success) {
          this.currentDocMag = this.Items.mag.pid;
          this.currentArticle.docmag = this.currentDocMag;
          this.currentArticle.docnum = response.data.pid;
          this.currentArticle.docpid = response.data.pid;
          this.Items.docnum = response.data.numdoc;
          this.Items.docpid = response.data.pid;
          this.appliquerListeEntete(response.data.m);

          this.resetArticleForm();
          this.showSuccess(response.data.message);
          this.isArticleView = true;
        } else {
          this.showError(this.formatErrorMessages(response.data));
        }
      } catch (error) {
        this.showError('Une erreur est survenue. Veuillez contacter votre administrateur.');
      } finally {
        this.$store.dispatch('lancerchargement', false);
      }
    },

    async updateDocument() {
      if (!this.validateDocument()) return;

      this.$store.dispatch('lancerchargement', true);

      try {
        const url = `${process.env.VUE_APP_API_URL}/jkebfgescomporziprodpfachatventeegl745874stock771714dfe/gescom/default/vmaj/${this.documentCategory}/${this.documentType}/${this.$store.state.appsociete}/${randomString()}`;

        // sansliste : le serveur ne renvoie plus la liste d'articles avec l'en-tête
        const response = await axios.post(url, { ...this.Items, sansliste: 1 }, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JwtService.getToken()}`,
            'csrftoken': this.$store.state.appsociete,
          },
          withCredentials: true,
        });

        if (response.data.success) {
          this.currentDocMag = this.Items.mag.pid;
          this.currentArticle.docmag = this.currentDocMag;
          this.appliquerListeEntete(response.data.m);
          this.resetArticleForm();
          this.calculateDocumentTotals();
          this.showSuccess(response.data.message);
          this.isArticleView = true;
        } else {
          this.showError(this.formatErrorMessages(response.data));
        }
      } catch (error) {
        this.showError('Une erreur est survenue. Veuillez contacter votre administrateur.');
      } finally {
        this.$store.dispatch('lancerchargement', false);
      }
    },

    validateDocument() {
      if (!this.Items.mag || !this.Items.datedoc || !this.Items.docobservation || !this.Items.jsonotherdonne?.cltfrs) {
        this.showError('Veuillez saisir toutes les informations requises (date, entrepôt, client/fournisseur, motif)');
        return false;
      }
      return true;
    },

    // ============ ARTICLE METHODS ============
    resetArticleForm() {
      this.currentArticle = {
        ...this.createEmptyArticle(),
        docmag: this.currentDocMag,
        docnum: this.Items.docpid || this.Items.pid,
        docpid: this.Items.docpid || this.Items.pid,
        doctp: this.Items.doctyp,
      };
      this.articleQuantity = 0;
      this.isArticleDisabled = false;
    },

    selectArticleLine(line) {
      this.isArticleDisabled = true;
      this.currentArticle = {
        article: line.article,
        qtite: line.qtite,
        diqte: 0,
        pu: parseFloat(line.ppu || line.pu),
        pa: parseFloat(line.pu),
        mtnt: line.mtnt,
        docnumother: line.docnumother,
        remise: line.remise,
        calmtntht: line.calmtntht,
        autredesignation: line.autredesignation,
        doctp: line.doctyp,
        pid: line.pid,
        linekey: line.linekey,
        etatline: line.etatline,
        docpid: line.docnum,
        docnum: line.docnum,
        docmag: this.currentDocMag,
      };
      this.articleQuantity = line.qtite;
    },

    async saveArticleLine() {
      if (!this.validateArticle()) return;

      const linekey = this.currentArticle.linekey || randomString(8);
      const isNew = !this.currentArticle.linekey;

      // Prepare article data
      this.currentArticle.linekey = linekey;
      this.currentArticle.etatline = 0;
      this.currentArticle.ppu = this.documentCategory === 'vente' ? this.currentArticle.pu : this.currentArticle.pa;
      this.currentArticle.pu = this.documentCategory === 'vente' ? this.currentArticle.pu : this.currentArticle.pa;
      this.currentArticle.calmtntht = parseFloat(this.currentArticle.remise || 0) + parseFloat(this.currentArticle.mtnt);

      const articleData = cloneobjet(this.currentArticle);

      if (isNew) {
        this.articleLines.push(articleData);
      } else {
        const index = this.articleLines.findIndex(l => l.linekey === linekey);
        if (index !== -1) {
          this.articleLines[index] = { ...this.articleLines[index], ...articleData };
        }
      }

      this.resetArticleForm();
      this.calculateDocumentTotals();
      this.processCount++;

      try {
        const url = `${process.env.VUE_APP_API_URL}/jkebfgescomporziprodpfachatventeegl745874stock771714dfe/gescom/default/vline/${this.documentCategory}/${this.documentType}/${this.$store.state.appsociete}/${randomString()}`;

        const response = await axios.post(url, articleData, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JwtService.getToken()}`,
            'csrftoken': this.$store.state.appsociete,
          },
          withCredentials: true,
        });

        this.processCount--;

        if (response.data.success) {
          this.updateLineStatus(linekey, 1, response.data.key);
          this.showSuccess(response.data.message);
        } else {
          this.updateLineStatus(linekey, 2, null, response.data.message);
          this.showError(response.data.message);
        }
      } catch (error) {
        this.processCount--;
        this.updateLineStatus(linekey, 2, null, 'Erreur lors du traitement');
        this.showError('Une erreur est survenue');
      }
    },

    async deleteArticleLine() {
      if (!this.validateArticle()) return;
      if (!this.currentArticle.linekey) return;

      const linekey = this.currentArticle.linekey;

      // If not saved to database yet
      if (!this.currentArticle.pid) {
        this.articleLines = this.articleLines.filter(l => l.linekey !== linekey);
        this.resetArticleForm();
        this.calculateDocumentTotals();
        return;
      }

      this.currentArticle.spid = this.currentArticle.docnum;
      const articleData = cloneobjet(this.currentArticle);

      this.resetArticleForm();
      this.calculateDocumentTotals();
      this.processCount++;

      try {
        const url = `${process.env.VUE_APP_API_URL}/jkebfgescomporziprodpfachatventeegl745874stock771714dfe/gescom/default/vline/${this.documentCategory}/${this.documentType}/${this.$store.state.appsociete}/${randomString()}`;

        const response = await axios.post(url, articleData, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${JwtService.getToken()}`,
            'csrftoken': this.$store.state.appsociete,
          },
          withCredentials: true,
        });

        this.processCount--;

        if (response.data.success) {
          this.articleLines = this.articleLines.filter(l => l.linekey !== linekey);
          this.calculateDocumentTotals();
          this.showSuccess(response.data.message);
        } else {
          this.updateLineStatus(linekey, 2, null, response.data.message);
          this.showError(response.data.message);
        }
      } catch (error) {
        this.processCount--;
        this.updateLineStatus(linekey, 2, null, 'Erreur lors de la suppression');
      }
    },

    validateArticle() {
      const hasArticle = this.currentArticle.article !== null;
      const hasQty = this.articleQuantity > 0;
      const hasPrice = this.documentCategory === 'vente'
          ? this.currentArticle.pu > 0
          : this.currentArticle.pa > 0;
      const hasAmount = this.currentArticle.mtnt > 0;

      if (!hasArticle || !hasQty || !hasPrice || !hasAmount) {
        this.showError('Veuillez saisir toutes les informations de l\'article');
        return false;
      }
      return true;
    },

    updateLineStatus(linekey, status, pid = null, message = null) {
      const line = this.articleLines.find(l => l.linekey === linekey);
      if (line) {
        line.etatline = status;
        if (pid && !line.pid) line.pid = pid;
        if (message) line.linemessage = message;
      }
    },

    // ============ PRICE CALCULATIONS ============
    calculateArticlePrice() {
      if (!this.currentArticle.article) return;

      const article = this.currentArticle.article;
      let price = 0;

      if (this.documentCategory === 'vente') {
        price = this.getSellingPrice(article);

        if (parseInt(this.Items.jsonotherdonne.appliquetva) === 1 && parseInt(article.tptva) === 1) {
          if (parseInt(article.typeprixvente) === 1) {
            price = parseFloat((price / 1.18).toFixed(8));
          }
        }

        this.currentArticle.pu = price;
      } else {
        if (parseInt(this.Items.jsonotherdonne.appliquetva) === 1 && parseInt(article.tptva) === 1) {
          if (parseInt(article.typeprixvente) === 1) {
            this.currentArticle.pa = Math.round(parseFloat(this.currentArticle.pa) / 1.18);
          }
        }
      }
    },

    getSellingPrice(article) {
      const priceType = this.Items.jsonotherdonne.mtypprixdevente;
      const priceMap = {
        prixvente: article.pu,
        prixvente1: article.pu1,
        prixvente2: article.pu2,
        prixvente3: article.pu3,
        prixvente4: article.pu4,
        prixvente5: article.pu5,
        prixvente6: article.pu6,
        prixvente7: article.pu7,
      };
      return priceMap[priceType] || article.pu;
    },

    calculateDocumentTotals() {
      let totalHT = 0, totalTVA = 0, totalDiscount = 0, totalTaxable = 0, totalNonTaxable = 0;
      const applyTVA = parseInt(this.Items.jsonotherdonne.appliquetva) === 1;

      this.articleLines.forEach(line => {
        if ([0, 1, 4].includes(parseFloat(line.etatline))) {
          const amount = parseFloat(line.mtnt) || 0;
          const discount = parseFloat(line.remise) || 0;
          const article = line.article;

          totalDiscount += discount;

          if (article?.taxedimposition !== 'A') {
            if (applyTVA && parseInt(article?.tptva) === 1) {
              totalTaxable += amount;
            } else {
              totalNonTaxable += amount;
            }
          } else {
            totalNonTaxable += amount;
          }
        }
      });

      totalHT = totalTaxable + totalNonTaxable;

      if (applyTVA) {
        totalTVA = totalTaxable * 0.18;
      }

      const aibRate = parseInt(this.Items.jsonotherdonne.aib) || 0;
      let totalAIB = 0;
      let libAIB = 'AIB';

      if (aibRate > 0) {
        libAIB = `Montant AIB (${aibRate}%)`;
        totalAIB = totalHT * (aibRate / 100);

        if (['DAF', 'BCF', 'RF', 'FR', 'FRF'].includes(this.documentType)) {
          totalAIB = -totalAIB;
          const netFinancier = totalHT + totalAIB;
          if (applyTVA) totalTVA = netFinancier * 0.18;
        }
      }

      const totalTTC = ['DAF', 'BCF', 'RF', 'FR', 'FRF'].includes(this.documentType)
          ? (totalHT + totalAIB) + totalTVA
          : totalHT + totalAIB + totalTVA;

      this.Items.mtnt = {
        doctva: Math.round(totalTVA),
        docmtnttotalttc: Math.round(totalTTC),
        docmtntaib: Math.round(totalAIB),
        docmtntremise: Math.round(totalDiscount),
        docmtnttotalht: Math.round(totalHT),
        doccalmtnttotalht: Math.round(totalHT + totalDiscount),
        libaib: libAIB,
      };
    },

    // ============ MODAL OPENERS ============
    openClientSupplierModal() {
      const type = this.documentCategory === 'vente' ? 'clt' : 'frs';
      const title = this.documentCategory === 'vente' ? 'Liste des clients' : 'Liste des fournisseurs';
      const customLabels = JwtService.getCUSTOMLIBELLEFRSCLT();

      this.$refs.modallistfrsclt.show(
          title,
          this.clientSupplierList,
          type,
          this.inputLabels,
          customLabels ? JSON.parse(customLabels) : this.$store.state.appcustomlibellefrsclt
      );
    },

    openCollaboratorModal() {
      this.$refs.modallistfrsclt.show(
          'Liste des collaborateurs',
          this.alldata.collaborateur || [],
          'col',
          this.inputLabels,
          {}
      );
    },

    openArticleModal() {
      this.$refs.modallistedesarticles.show(
          'Liste des articles',
          'vente',
          this.productList,
          this.documentCategory
      );
    },

    // ============ EVENT HANDLERS ============
    handleClientSupplierSelected(selection) {
      if (selection.typ === 'col') {
        this.Items.jsonotherdonne.collaborateur = selection.value;
        this.alldata.collaborateur = selection.datatable;
      } else {
        this.Items.jsonotherdonne.cltfrs = selection.value;
        this.clientSupplierList = selection.datatable;
      }
    },

    handleArticleSelected(selection) {
      const article = selection.value;

      // Check if already in list
      const existing = this.articleLines.find(l => l.article?.pid === article?.pid);
      if (existing && !this.currentArticle.pid) {
        this.showError(`${article.libelle} existe déjà dans la liste`);
        toastr['error'](`${article.libelle} existe déjà dans la liste`,"<b></b>");
        this.selectArticleLine(existing);
        return;
      }

      this.currentArticle.article = article;
      this.currentArticle.pa = article?.pa || 0;
      this.calculateArticlePrice();
    },

    toggleHeaderMenu() {
      this.showHeaderMenu = !this.showHeaderMenu;
    },

    switchToHeaderView() {
      this.isArticleView = false;
      this.showHeaderMenu = false;
    },

    // ============ UTILITIES ============
    formatCurrency(value) {
      return currencyFormatDE(Number(value) || 0);
    },

    formatNumber(value) {
      return FormatNumber(Number(value) || 0);
    },

    formatErrorMessages(data) {
      if (data.datamessage?.length > 0) {
        return data.datamessage.join(', ');
      }
      return data.message || 'Une erreur est survenue';
    },

    getStatusClass(status) {
      const classes = {
        0: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
        1: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
        2: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
        4: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
      };
      return classes[status] || classes[0];
    },

    getStatusDotClass(status) {
      const classes = {
        0: 'bg-blue-500',
        1: 'bg-green-500',
        2: 'bg-red-500',
        4: 'bg-red-500',
      };
      return classes[status] || classes[0];
    },

    getStatusLabel(status) {
      const labels = { 0: 'En attente', 1: 'OK', 2: 'Erreur', 4: 'Erreur' };
      return labels[status] || 'En attente';
    },

    showSuccess(message) {
      this.successMessage = message;
      this.errorMessage = '';
      setTimeout(() => { this.successMessage = ''; }, 5000);
    },

    showError(message) {
      this.errorMessage = message;
      this.successMessage = '';
    },

    clearMessages() {
      this.successMessage = '';
      this.errorMessage = '';
    },
  },

  beforeUnmount() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; }
.cf-foot-info { font-size:0.8rem; color:var(--cf-muted); font-weight:500; }
.cf-process { display:inline-flex; align-items:center; gap:0.45rem; color:rgb(var(--warning)); font-weight:600; }

/* Menu Options (en-tête) */
.cf-headmenu { position:relative; }
.cf-headmenu-list { left:0; right:auto; }
.ag-menu { position:absolute; top:calc(100% + 4px); right:0; z-index:30; min-width:180px; padding:0.3rem; list-style:none; margin:0; background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); box-shadow:var(--cf-shadow-md); }
.ag-menu-item { display:flex; align-items:center; width:100%; padding:0.45rem 0.6rem; border:0; background:transparent; font-size:0.8rem; color:var(--cf-ink); text-align:left; cursor:pointer; border-radius:var(--cf-radius-xs); white-space:nowrap; }
.ag-menu-item:hover { background:var(--cf-surface-alt); }

/* Alertes */
.cf-alert-zone { padding:0.85rem 1.25rem 0; flex-shrink:0; }
.cf-alert { display:flex; align-items:center; gap:0.6rem; padding:0.7rem 0.9rem; border-radius:var(--cf-radius-sm); font-size:0.82rem; border:1px solid; }
.cf-alert i { font-size:1.1rem; flex-shrink:0; }
.cf-alert--success { background:#ecfdf5; border-color:#a7f3d0; color:#047857; }
.cf-alert--danger { background:#fef2f2; border-color:#fecaca; color:#b91c1c; }

/* Onglets (style souligné) */
.cf-tabs { display:flex; gap:2px; border-bottom:1px solid var(--cf-border); overflow-x:auto; }
.fa2-tab { position:relative; display:flex; align-items:center; gap:6px; padding:10px 16px; font-size:0.82rem; font-weight:600; border:none; border-bottom:2px solid transparent; background:none; cursor:pointer; transition:all .15s; white-space:nowrap; color:var(--cf-muted); }
.fa2-tab:hover { color:var(--cf-ink); background:rgb(var(--primary)/0.06); }
.fa2-tab--active { color:rgb(var(--primary))!important; border-bottom-color:rgb(var(--primary)); background:rgb(var(--primary)/0.08); }

/* Champs */
.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-req { color:rgb(var(--danger)); }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-inp--readonly, .cf-inp:disabled { background:var(--cf-surface-alt); color:var(--cf-muted); cursor:not-allowed; }
.cf-inp--amount { background:rgb(var(--primary) / 0.08); border-color:rgb(var(--primary) / 0.25); color:rgb(var(--primary)); font-weight:600; }
.cf-textarea { height:auto; padding:10px 12px; resize:vertical; line-height:1.5; }
.cf-select-wrap { position:relative; }
.cf-select { appearance:none; padding-right:28px; cursor:pointer; }
.cf-select:disabled { background:var(--cf-surface-alt); color:var(--cf-muted); cursor:not-allowed; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }

/* Sous-panneau formulaire article */
.cf-subpanel { padding:1rem; border-radius:var(--cf-radius-sm); background:var(--cf-surface); border:1px solid var(--cf-border); }
.cf-subpanel-actions { border-top:1px solid var(--cf-border); }

/* Table */
.cf-table-wrap { overflow:auto; border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); }
.cf-table { width:100%; border-collapse:collapse; font-size:0.82rem; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.th--right { text-align:right; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; }
.td--center { text-align:center; }
.td--right { text-align:right; }
.cf-line-error { background:#fef2f2; color:#b91c1c; font-size:0.78rem; }
.cf-cell-main { margin:0; font-weight:600; color:var(--cf-ink-strong); }
.cf-cell-sub { margin:2px 0 0; font-size:0.75rem; color:var(--cf-muted); }
.cf-cell-strong { font-weight:600; color:var(--cf-ink-strong); }

/* Totaux (tfoot) */
.cf-tfoot tr { border-top:1px solid var(--cf-border); }
.cf-tfoot-label { color:var(--cf-muted); font-weight:500; }
.cf-tfoot-val { font-weight:700; color:var(--cf-ink-strong); }
.cf-neg { color:rgb(var(--danger)); }
.cf-tfoot-total td { background:rgb(var(--primary) / 0.08); color:rgb(var(--primary)); font-weight:700; border-top:2px solid rgb(var(--primary) / 0.25); }
.cf-tfoot-amount { font-size:0.95rem; }

/* Badge de statut (couleurs fournies par getStatusClass/getStatusDotClass) */
.cf-badge { display:inline-flex; align-items:center; gap:5px; padding:2px 9px; font-size:0.72rem; font-weight:600; border-radius:999px; }
.cf-badge-dot { width:6px; height:6px; border-radius:999px; }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

/* Cartes mobile */
.cf-card { border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); overflow:hidden; background:#fff; }
.cf-card-head { display:flex; align-items:center; justify-content:space-between; padding:0.6rem 0.85rem; background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); }
.cf-card-index { font-size:0.8rem; font-weight:600; color:var(--cf-ink-strong); }
.cf-card-body { padding:0.85rem; }
.cf-card-title { font-weight:600; color:var(--cf-ink-strong); margin:0 0 0.6rem; }
.cf-card-sub { font-size:0.78rem; color:var(--cf-muted); margin:-0.35rem 0 0.6rem; }
.cf-card-lbl { font-size:0.72rem; color:var(--cf-muted); margin:0; }
.cf-card-val { font-size:0.85rem; font-weight:600; color:var(--cf-ink); margin:2px 0 0; }
.cf-card-val--primary { color:rgb(var(--primary)); font-weight:700; }
.cf-card-link { background:none; border:none; color:rgb(var(--primary)); font-size:0.82rem; font-weight:600; cursor:pointer; }
.cf-card-error { padding:0.5rem 0.85rem; background:#fef2f2; color:#b91c1c; font-size:0.78rem; border-top:1px solid #fecaca; }

/* Carte totaux mobile */
.cf-totals-card { background:rgb(var(--primary)); border-radius:var(--cf-radius-sm); padding:1rem; color:#fff; }
.cf-totals-row { display:flex; justify-content:space-between; font-size:0.82rem; color:rgb(255 255 255 / 0.85); padding:2px 0; }
.cf-totals-row--net { border-top:1px solid rgb(255 255 255 / 0.35); margin-top:6px; padding-top:8px; font-size:0.95rem; font-weight:700; color:#fff; }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
.dropdown-enter-active, .dropdown-leave-active { transition:all 0.2s ease; transform-origin:top; }
.dropdown-enter-from, .dropdown-leave-to { opacity:0; transform:scaleY(0.95); }

/* Loading animation */
.animate-spin { animation:spin 1s linear infinite; }
@keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }

.cf-dialog-body::-webkit-scrollbar, .cf-table-wrap::-webkit-scrollbar { width:6px; height:6px; }
.cf-dialog-body::-webkit-scrollbar-thumb, .cf-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } .cf-dialog { max-height:96vh; } .cf-overlay { padding:0.5rem; } }
</style>
